import { useSelector } from "react-redux"
import { selectShipment } from "../shipmentSlice"
import { COURIER_DELIVERY_TYPE, LOCAL_CARGO_DELIVERY_TYPE, VISIT_OFFICE_DELIVERY_TYPE } from "../../../data/static-data"
import { useTranslation } from "react-i18next"

const AfterSendingSubscription = () => {
  const {t} = useTranslation();
  const shipment = useSelector(selectShipment)
  if(!shipment) return <></>
    return (
      <>
          <div className="text-left mt-6">
          <p> 
                    {
                        shipment["getting-package-type"] === COURIER_DELIVERY_TYPE &&
                        <>
                            <div className="text-emerald-600 text-xl font-medium">
                                {t("send_to_akad.getting_package_types.courier.title")}:
                            </div>
                            <div 
                                className="ml-6 text-gray-700"
                            >
                                {t("send_to_akad.getting_package_types.courier.description")}
                            </div>
                        </>
                    }
                    {
                        shipment["getting-package-type"] === VISIT_OFFICE_DELIVERY_TYPE &&
                        <>
                            <div className="text-emerald-600 text-xl font-medium">
                                {t("send_to_akad.getting_package_types.visit_office.title")}:
                            </div>
                            <div 
                                className="ml-6 text-gray-700"
                            >
                                {t("send_to_akad.getting_package_types.visit_office.description")}
                            </div>
                        </>
                    }
                    {
                        shipment["getting-package-type"] === LOCAL_CARGO_DELIVERY_TYPE &&
                        <>
                            <div className="text-emerald-600 text-xl font-medium">
                                {t("send_to_akad.getting_package_types.local_cargo.title")}:
                            </div>
                            <div 
                                className="ml-6 text-gray-700"
                            >
                                {t("send_to_akad.getting_package_types.local_cargo.description")}
                            </div>
                        </>
                    }
                </p>
          </div>
      </>
  )
}

export default AfterSendingSubscription